import Splide from '@splidejs/splide';

export function CarouselStory() {
    const setCarousel = ($container) => {

        // settings
        const largeBreakpoint = $container.getAttribute('data-large-breakpoint') ?? 1024;
        const mediumBreakpoint = $container.getAttribute('data-medium-breakpoint') ?? 768;
        const largeCount = $container.getAttribute('data-large') ?? 3;
        const mediumCount = $container.getAttribute('data-medium') ?? largeCount;
        const smallCount = $container.getAttribute('data-small') ?? largeCount;
        const autoplay = $container.getAttribute('data-autoplay').toLowerCase() !== 'false';
        const autoplayTimeout = $container.getAttribute('data-autoplay-timeout') ?? 800;
        const lazyLoad = $container.getAttribute('data-lazyload');
        const nav = $container.getAttribute('data-nav');
        const largeStagePadding = $container.getAttribute('data-stagepadding-large');
        const mediumStagePadding = $container.getAttribute('data-stagepadding-medium');
        const smallStagePadding = $container.getAttribute('data-stagepadding-small');

        // responsive settings
        const popupSliderOptions = {
            type: 'loop',
            perPage: largeCount,
            perMove: 1,
            focus: 'center',
            trimSpace: false,
            arrows: true,
            start: 1,
            pagination: false,
            gap: '',
            autoHeight: true,
            autoWidth: true,
            autoplay: autoplay,
            speed: autoplayTimeout,
            updateOnMove: true,
            throttle: 300,
        };

        const responsiveSettings = {
            0: { perPage: smallCount },
            320: { perPage: smallCount }
        };
        responsiveSettings[mediumBreakpoint] = {
            perPage: mediumCount

        };
        responsiveSettings[largeBreakpoint] = {
            perPage: largeCount
        };

        // set carousel
        let popupSlider = new Splide($container, popupSliderOptions).mount();
        popupSlider.on('move', function () {
            /*if (document.querySelector('.right-slide')) {
                document.querySelector('.right-slide').classList.remove('right-slide');
            }

            if (document.querySelector('.left-slide')) {
                document.querySelector('.left-slide').classList.remove('left-slide');
            }*/
        });
    }

    const init = () => {
        const splideElems = document.getElementsByClassName('splide');
        if (splideElems.length) {
            for (var i = 0; i < splideElems.length; i++) {
                setCarousel(splideElems[i]);
            }
        }
    }

    init();
}